import React from "react";
import {toast} from 'react-toastify';
import ToastContent from '../../../ui/components/app-specific/toast-content';
import EnvService from "../env";

/**
 * @typedef {{
 *     title : string,
 *     message : string,
 *     buttons : any[],
 *     actions : any,
 *     hideTicketSubmission : boolean,
 *     props : Partial<import('react-toastify').ToastOptions>,
 * }} ToastServiceProps
 */

/**
 * The interface for showing toasts in the application.
 */
class ToastService {

    /**
     * Shows an error toast for the user with the given props.
     *
     * @param {Partial<ToastServiceProps>} data
     * @return {import('react-toastify').Id}
     */
    static error(data) {
        const {
            title = '',
            message = '',
            hideTicketSubmission = true,
            buttons = [],
            actions,
            props = {},
        } = data;
        const hideTicket = hideTicketSubmission || !EnvService.DEV_showErrorTicketSubmission;
        return toast.error((props) =>
                <ToastContent
                    title={title}
                    message={message?.replace('Severity: Error', '')}
                    buttons={buttons}
                    actions={actions}
                    toastProps={props}
                    hideTicketSubmission={hideTicket}
                />,
            {
                autoClose: hideTicket ? 5000 : false,
                closeOnClick: hideTicket,
                toastId: ((title ?? "") + (message ?? "")),
                ...props
            },
        );
    }


    /**
     * Shows a warning toast for the user with the given props.
     *
     * @param {Partial<ToastServiceProps>} data
     * @return {import('react-toastify').Id}
     */
    static warning(data) {
        const {
            title = '',
            message = '',
            buttons = [],
            actions,
            hideTicketSubmission = true,
            props = {},
        } = data;
        return toast.warning((props) =>
                <ToastContent
                    title={title}
                    message={message}
                    buttons={buttons}
                    actions={actions}
                    toastProps={props}
                    hideTicketSubmission={hideTicketSubmission}
                />,
            {
                toastId: ((title ?? "") + (message ?? "")),
                ...props
            },
        );
    }

    /**
     * Shows a success toast for the user with the given props.
     *
     * @param {Partial<ToastServiceProps>} data
     * @return {import('react-toastify').Id}
     */
    static success(data) {
        const {
            title = '',
            message = '',
            buttons = [],
            actions,
            hideTicketSubmission = true,
            props = {},
        } = data;
        return toast.success((props) =>
                <ToastContent
                    title={title}
                    message={message}
                    buttons={buttons}
                    actions={actions}
                    toastProps={props}
                    hideTicketSubmission={hideTicketSubmission}
                />,
            {
                toastId: ((title ?? "") + (message ?? "")),
                ...props
            },
        );
    }

    /**
     * Shows an info toast for the user with the given props.
     */
    static mainAPIRedZoneWarning() {
        if (EnvService.showInMainEnvironment) {
            ToastService.warning({
                title: "STOP!!",
                message: "You are using the main API in the development environment and are entering a RED ZONE area. Please be careful.",
                props: {
                    autoClose: false,
                    position: 'top-center',
                    toastId: 'main-api-warning',
                },
            })
        }
    }
}

export default ToastService;
